// Subscription-Widget-Comment JS

class CartSellingPlanSelect extends HTMLElement {
  constructor() {
    super();
    this.selectedSellingPlanValue = null;
    this._isUpdating = false;
  }

  async connectedCallback() {
    // Query child elements here (not in constructor) because when the element
    // is created via innerHTML replacement (e.g. cart drawer re-render), the
    // constructor fires before children are available in the DOM.
    this.selling_plan_tab_one_time = this.querySelector(
      "input.sellingplan_tab.one-time",
    );
    this.selling_plan_select = this.querySelector(".selling_plan-select");

    if (!this.selling_plan_tab_one_time || !this.selling_plan_select) {
      console.warn("cart-selling-plan-select: child elements not found");
      return;
    }

    this._boundChangeHandler = this.changeCartSellingPlan.bind(this);
    this.selling_plan_select.addEventListener(
      "change",
      this._boundChangeHandler,
    );
    this.selling_plan_tab_one_time.addEventListener(
      "input",
      this._boundChangeHandler,
    );

    this.cart = await getCartElement();
    if (!this.cart) {
      return;
    }

    if (window.location.href.indexOf("/products") !== -1) {
      this.setHiddenInputValue();
    }

    // Listen for cart updates using the theme's event system
    this._cartUpdatedHandler = (event) => {
      if (event) this.checkGoodieProducts(event);
    };
    document.documentElement.addEventListener(
      "cart:updated",
      this._cartUpdatedHandler,
    );

    // Initial check
    this.checkGoodieProducts();

    // If there's an active subscription on some cart items, restore the
    // selectedSellingPlanValue and dropdown from the server-rendered state.
    if (this.selectedPlan !== "null" && this.selectedPlan != null) {
      const weeks = Number(this.selectedPlan);
      if (!isNaN(weeks)) {
        this.selectedSellingPlanValue = weeks;
        this.selling_plan_select.value = String(weeks);
      }
    }
  }

  get goodieIds() {
    const ids = this.dataset.addGoodies
      ? this.dataset.addGoodies.split(",").filter((id) => id.trim() !== "")
      : [];
    return ids;
  }
  get selectedPlan() {
    return this.dataset.selectedPlan;
  }

  get itemsToRemove() {
    const ids = this.dataset.cartGoodies
      ? this.dataset.cartGoodies.split(",").filter((id) => id.trim() !== "")
      : [];
    return ids;
  }

  get removeGoodies() {
    return this.dataset.removeGoodies === "true";
  }

  disconnectedCallback() {
    if (this._cartUpdatedHandler) {
      document.documentElement.removeEventListener(
        "cart:updated",
        this._cartUpdatedHandler,
      );
    }
    if (this._boundChangeHandler) {
      if (this.selling_plan_select) {
        this.selling_plan_select.removeEventListener(
          "change",
          this._boundChangeHandler,
        );
      }
      if (this.selling_plan_tab_one_time) {
        this.selling_plan_tab_one_time.removeEventListener(
          "input",
          this._boundChangeHandler,
        );
      }
    }
  }
  createAddArray() {
    let add_items = [];

    // On the full /cart page, line items are plain <tr> without data attributes.
    // Fall back to the cart JSON we fetched from the API if available.
    if (this._cartJSON && this._cartJSON.items) {
      this._cartJSON.items.forEach((item) => {
        // Skip goodies — they'll be re-added by the goodie logic
        if (item.properties && item.properties._isGoodie) return;

        let new_selling_plan_id = null;
        if (
          this.selectedSellingPlanValue != null &&
          this._sellingPlanMap &&
          this._sellingPlanMap[item.product_id]
        ) {
          const plans = this._sellingPlanMap[item.product_id];
          new_selling_plan_id =
            plans[String(this.selectedSellingPlanValue)] || null;
        }

        let add_item = {
          id: item.variant_id,
          quantity: item.quantity,
          selling_plan: new_selling_plan_id,
        };

        // Preserve line item properties (excluding internal ones)
        if (item.properties && Object.keys(item.properties).length > 0) {
          const filteredProps = {};
          for (const [key, val] of Object.entries(item.properties)) {
            if (!key.startsWith("_") && val !== null && val !== "") {
              filteredProps[key] = val;
            }
          }
          if (Object.keys(filteredProps).length > 0) {
            add_item.properties = filteredProps;
          }
        }

        add_items.push(add_item);
      });
    } else {
      // Mini-cart / drawer path: scrape from DOM elements
      let cart_items = this.cart
        ? this.cart.querySelectorAll(".cart-item")
        : [];
      if (cart_items.length === 0 && this.cart) {
        cart_items = this.cart.querySelectorAll("line-item");
      }

      cart_items.forEach((item) => {
        let variant_id = item.dataset.variantId;
        if (!item.querySelector("special-product")) {
          // Try multiple quantity input patterns for compatibility
          let quantityInput =
            item.querySelector('quantity-popover input[type="number"]') ||
            item.querySelector('input[name="updates[]"]') ||
            item.querySelector(".quantity-selector__input");
          let quantity = quantityInput ? quantityInput.value : 1;

          let selling_plan_ids;
          let new_selling_plan_id = null;

          if (item.dataset.sellingPlanIds != undefined) {
            selling_plan_ids = item.dataset.sellingPlanIds.split(",");
          }

          if (
            this.selectedSellingPlanValue != null &&
            item.dataset.sellingPlanIds != undefined
          ) {
            // selectedSellingPlanValue is a week number (2,4,6,...14)
            // Convert to array index for DOM fallback: (weeks / 2) - 1
            const planIndex = this.selectedSellingPlanValue / 2 - 1;
            new_selling_plan_id = selling_plan_ids[planIndex];
            if (new_selling_plan_id == undefined) {
              new_selling_plan_id = null;
            }
          }

          let add_item = {
            id: variant_id,
            quantity,
            selling_plan: new_selling_plan_id,
          };
          if (
            item.dataset.properties &&
            item.dataset.properties.trim() !== ""
          ) {
            const props = item.dataset.properties;
            try {
              const parsedProps = JSON.parse(props);
              if (
                parsedProps &&
                typeof parsedProps === "object" &&
                !Array.isArray(parsedProps)
              ) {
                add_item.properties = parsedProps;
              }
            } catch (e) {
              console.error("Error parsing data-properties:", e);
            }
          }
          add_items.push(add_item);
        } else if (item.querySelector("special-product")) {
          if (
            item.querySelector("special-product input[type='checkbox']").checked
          ) {
            let add_item = {
              id: variant_id,
              quantity: 1,
            };
            add_items.push(add_item);
          }
        }
      });
    }

    if (this.selectedSellingPlanValue != null && this.goodieIds.length) {
      this.goodieIds.forEach((id) => {
        add_items.push({
          id: id,
          quantity: 1,
          properties: {
            _isGoodie: "sub",
          },
        });
      });
    }
    add_items.reverse();
    let add_arrays = splitArray(add_items, 20);
    return add_arrays;
  }

  async changeCartSellingPlan(event) {
    if (
      event.target.closest(".sellingplan_tab")?.classList.contains("one-time")
    ) {
      this.selectedSellingPlanValue = null;
      // Reset dropdown so toggling back to subscribe doesn't look pre-applied
      this.selling_plan_select.selectedIndex = 0;
    } else {
      this.selectedSellingPlanValue = event.target.value;
    }

    if (this.selectedSellingPlanValue != null) {
      this.selectedSellingPlanValue = Number(this.selectedSellingPlanValue);

      const d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      document.cookie = `active_selling_plan=${event.target.value}; expires=${d.toUTCString()}; path=/;`;
    }

    // Change Hidden Input when on PDP
    if (window.location.href.indexOf("/products") !== -1) {
      this.setHiddenInputValue();
    }

    // Prevent concurrent cart rebuilds — if one is already in flight,
    // flag that a new change is pending and bail. When the current run
    // finishes it will see the flag and re-run with the latest value.
    if (this._isUpdating) {
      this._pendingUpdate = true;
      return;
    }
    this._isUpdating = true;

    try {
      await this._rebuildCart();
    } finally {
      this._isUpdating = false;

      // If the user changed the dropdown while we were working, run again
      // with whatever the latest selectedSellingPlanValue is now.
      if (this._pendingUpdate) {
        this._pendingUpdate = false;
        await this.changeCartSellingPlan(event);
      }
    }
  }

  async _rebuildCart() {
    // Determine if this widget instance lives inside the mini-cart drawer
    // vs. the full /cart page. On /cart both exist in the DOM, so checking
    // the URL alone would cause the drawer's widget to reload the page.
    const isInDrawer = !!this.closest("cart-drawer");
    const useAjaxRefresh = isInDrawer;

    // Fetch cart data from the API. This is reliable for both contexts —
    // the full cart page doesn't have data attributes on its <tr> elements,
    // and the mini-cart DOM may be stale after a re-render.
    const cartRes = await fetch(window.Shopify.routes.root + "cart.js").then(
      (r) => r.json(),
    );
    this._cartJSON = cartRes;

    // Build a map of product_id [selling_plan_id, ...] in group order
    // by fetching each unique product's JSON.
    const productIds = [...new Set(cartRes.items.map((i) => i.product_id))];
    this._sellingPlanMap = {};
    await Promise.all(
      productIds.map(async (pid) => {
        try {
          const handle = cartRes.items.find((i) => i.product_id === pid).handle;
          const prodRes = await fetch(
            window.Shopify.routes.root + "products/" + handle + ".js",
          ).then((r) => r.json());
          const plansByWeeks = {};
          const fallbackPlans = {};
          if (prodRes.selling_plan_groups) {
            for (const group of prodRes.selling_plan_groups) {
              for (const plan of group.selling_plans) {
                const lowerName = plan.name.toLowerCase();
                const isGerman = lowerName.includes("wochen");
                const isEnglish = lowerName.includes("week");
                if (!isGerman && !isEnglish) continue;
                const match = plan.name.match(/(\d+)/);
                if (!match) continue;
                const weekNum = match[1];
                if (isGerman) {
                  // German plans always take priority
                  plansByWeeks[weekNum] = plan.id;
                } else if (!fallbackPlans[weekNum]) {
                  // English plans are fallback only
                  fallbackPlans[weekNum] = plan.id;
                }
              }
            }
            // Fill in any gaps with English fallback plans
            for (const [weekNum, planId] of Object.entries(fallbackPlans)) {
              if (!plansByWeeks[weekNum]) {
                plansByWeeks[weekNum] = planId;
              }
            }
          }
          this._sellingPlanMap[pid] = plansByWeeks;
        } catch (e) {
          console.error("Error fetching product selling plans:", e);
        }
      }),
    );

    const addArrays = this.createAddArray();

    window.sessionStorage.setItem(
      "add-selling-plan-arrays",
      JSON.stringify(addArrays),
    );

    // Step 1: Clear cart and wait for completion
    await fetch(window.Shopify.routes.root + "cart/clear.js").then((r) =>
      r.json(),
    );

    // Step 2: Add items back one batch at a time (sequential to avoid race conditions)
    for (const array of addArrays) {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: array,
          }),
        },
      );
      const addResult = await addResponse.json();
      if (addResult.errors) {
        console.error("Error updating cart selling plan:", addResult.errors);
        return;
      }
    }

    // On the full /cart page, do a hard reload to show the updated state.
    // The page isn't built for AJAX section rendering like the mini-cart is.
    if (!useAjaxRefresh) {
      window.location.reload();
      return;
    }

    // Step 3: Fetch the full cart state with sections (mini-cart path)
    const cartResponse = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sections: this._getSections(),
          sections_url: window.location.pathname,
        }),
      },
    );
    const parsedState = await cartResponse.json();
    if (parsedState.errors) {
      console.error("Error fetching cart state:", parsedState.errors);
      return;
    }

    this._refreshCart(parsedState);
    document.dispatchEvent(new CustomEvent("selling-plan::changed"));
  }

  // If on PDP change hidden input value
  setHiddenInputValue() {
    let selling_plan_input = document.querySelector(
      "input[name='selling_plan']",
    );
    if (
      this.querySelector(".sellingplan_tab.one-time:checked") &&
      selling_plan_input != undefined
    ) {
      selling_plan_input.value = "";
    } else if (selling_plan_input != undefined) {
      selling_plan_input.value = document
        .querySelector(".selling_plan_ids")
        ?.dataset.sellingPlanIds.split(",")[this.selling_plan_select.value];
    }
  }

  async removeFreeProducts() {
    if (this.itemsToRemove.length > 0) {
      let cartAction = "cart/update.js";
      const updates = {};
      this.itemsToRemove.forEach((id) => {
        updates[id] = 0;
      });
      await fetch(window.Shopify.routes.root + cartAction, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: this._getSections(),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            console.error(parsedState.errors);
            return;
          }
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");
          this.cart?.classList.toggle("is-empty", parsedState.item_count === 0);
          if (cartFooter)
            cartFooter.classList.toggle(
              "is-empty",
              parsedState.item_count === 0,
            );
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0,
            );
          this._refreshCart(parsedState);
        });
    }
  }
  async checkGoodieProducts() {
    if (
      (this.selectedPlan == "null" || this.removeGoodies == true) &&
      this.itemsToRemove.length > 0
    ) {
      await this.removeFreeProducts();
    } else if (
      this.selectedPlan != "null" &&
      this.goodieIds &&
      this.goodieIds.length > 0
    ) {
      if (!this.cart)
        this.cart =
          document.querySelector("cart-items") ||
          document.querySelector("cart-drawer-items") ||
          document.querySelector("cart-drawer");
      const goodies = [];
      this.goodieIds.forEach((id) => {
        goodies.push({
          id: id,
          quantity: 1,
          properties: {
            _isGoodie: "sub",
          },
        });
      });
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: goodies,
          sections: this._getSections(),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            console.error(
              "Error updating cart selling plan:",
              parsedState.errors,
            );
            return;
          }
          this._refreshCart(parsedState);
        });
    }
  }
  _getSections() {
    if (this.cart && typeof this.cart.getSectionsToRender === "function") {
      return this.cart.getSectionsToRender().map((section) => section.section);
    }
    return ["mini-cart"];
  }

  _refreshCart(parsedState) {
    if (this.cart && typeof this.cart.renderContents === "function") {
      this.cart.renderContents(parsedState);
    } else {
      // Use this theme's cart:refresh event pattern
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: parsedState,
            openMiniCart: false,
          },
        }),
      );
    }
  }

  close() {
    this.cart.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    this.cart.querySelector("information-popup[open]")?.removeAttribute("open");
  }
}
customElements.define("cart-selling-plan-select", CartSellingPlanSelect);

function splitArray(array, chunkSize) {
  let result = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
}

class TabComponentSubscription extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (event) => {
      if (event.target.dataset.openTab) {
        const tabId = event.target.dataset.openTab;
        const oldTabs = document.querySelectorAll(".tab__content.active");

        oldTabs.forEach((ele) => ele.classList.remove("active"));
        const tabElements = document.querySelectorAll(`#open-${tabId}`);
        tabElements.forEach((ele) => ele.classList.add("active"));
      }
    });
  }
}

customElements.define("tab-component-subscription", TabComponentSubscription);

// ── Safeguard: ensure the subscription widget always exists in the cart drawer ──
// After any cart:refresh (which replaces drawer innerHTML), check if the widget
// is still present. If not, fetch fresh section HTML and re-inject it.
(function ensureWidgetAlwaysExists() {
  document.documentElement.addEventListener("cart:refresh", function () {
    // Wait one frame for the theme's _rerenderCart to finish replacing DOM
    requestAnimationFrame(function () {
      const cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer) return;

      const footer = cartDrawer.querySelector(".mini-cart__drawer-footer");
      if (!footer) return;

      // Widget already exists — nothing to do
      if (footer.querySelector("cart-selling-plan-select")) return;

      // Widget is missing — fetch the mini-cart section to get fresh HTML
      const sectionId = cartDrawer.getAttribute("section") || "mini-cart";
      const cartUrl =
        (window.themeVariables &&
          window.themeVariables.routes &&
          window.themeVariables.routes.cartUrl) ||
        window.Shopify.routes.root + "cart";

      fetch(cartUrl + "?section_id=" + sectionId)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var temp = document.createElement("div");
          temp.innerHTML = html;
          var freshWidget = temp.querySelector("cart-selling-plan-select");
          if (freshWidget) {
            // Insert at the very beginning of the footer
            footer.insertBefore(freshWidget, footer.firstChild);
          }
        })
        .catch(function (e) {
          console.error("Error re-injecting subscription widget:", e);
        });
    });
  });
})();

async function getCartElement() {
  const cartItems = document.querySelector("cart-items");
  const cartDrawerItems = document.querySelector("cart-drawer-items");
  const cartDrawer = document.querySelector("cart-drawer");

  if (cartItems) {
    await customElements.whenDefined("cart-items");
    return cartItems;
  }

  if (cartDrawerItems) {
    await customElements.whenDefined("cart-drawer-items");
    return cartDrawerItems;
  }

  if (cartDrawer) {
    await customElements.whenDefined("cart-drawer");
    return cartDrawer;
  }

  console.warn(
    "No cart-items, cart-drawer-items, or cart-drawer element found in DOM!",
  );
  return null;
}
